import React, { useEffect, useState } from 'react';

interface DeleteReceiptModalProps {
    merchant: string;
    datetime: string;
    totalGross: number;
    currency: string;
    hasSplit: boolean;
    onConfirm: (deleteSplit: boolean) => void;
    onCancel: () => void;
}

const DeleteReceiptModal: React.FC<DeleteReceiptModalProps> = ({
    merchant,
    datetime,
    totalGross,
    currency,
    hasSplit,
    onConfirm,
    onCancel,
}) => {
    const [deleteSplit, setDeleteSplit] = useState(true);

    useEffect(() => {
        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onCancel();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [onCancel]);

    const getCurrencySymbol = (curr: string) => {
        const symbols: { [key: string]: string } = {
            'EUR': '€',
            'USD': '$',
            'GBP': '£',
            'CZK': 'Kč',
            'PLN': 'zł'
        };
        return symbols[curr] || curr;
    };

    return (
        <div
            onClick={onCancel}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                backdropFilter: 'blur(4px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2000,
                padding: '20px',
            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '30px',
                    maxWidth: '500px',
                    width: '100%',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
                }}
            >
                <h3 style={{ marginTop: 0, marginBottom: '20px', color: '#e74c3c' }}>
                    Vymazať bloček
                </h3>

                <p style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '20px', color: '#333' }}>
                    Naozaj chcete bloček od <strong>{merchant}</strong> zo dňa{' '}
                    <strong>{datetime}</strong>, vo výške{' '}
                    <strong>{totalGross.toFixed(2)} {getCurrencySymbol(currency)}</strong> vymazať?
                </p>

                <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
                    Vymazaním bločka sa upravia vaše výdavky a analýzy.
                </p>

                {hasSplit && (
                    <label
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            marginBottom: '25px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#333',
                        }}
                    >
                        <input
                            type="checkbox"
                            checked={deleteSplit}
                            onChange={(e) => setDeleteSplit(e.target.checked)}
                            style={{
                                width: '18px',
                                height: '18px',
                                cursor: 'pointer',
                            }}
                        />
                        Zároveň vymazať aj rozdelenie účtu
                    </label>
                )}

                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button
                        onClick={onCancel}
                        autoFocus
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#f0f0f0',
                            color: '#333',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                        }}
                    >
                        Zrušiť
                    </button>
                    <button
                        onClick={() => onConfirm(deleteSplit)}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#e74c3c',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                        }}
                    >
                        Vymazať
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteReceiptModal;
